import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import { saveCommentRequest } from "../../redux/Tickets/ticketSlice";
import { toast } from "react-toastify";

const TicketCommentsDrawer = ({ comments = [], ticketId }) => {
  const dispatch = useDispatch();

  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);

  // HANDLE FILE SELECT
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
    }
  };

  // HANDLE SEND
  const handleSend = () => {
    if (!message && !file) {
      toast.error("Please enter comment or select file");
      return;
    }

    dispatch(
      saveCommentRequest({
        ticketId,
        comment: message,
        file: file, // optional
      })
    );

    // reset
    setMessage("");
    setFile(null);
  };

  return (
    <Box>
      {/* HEADER */}
      <Typography fontWeight={600} fontSize={18} mb={2}>
        Comments
      </Typography>

      {/* COMMENTS LIST */}
      <Box sx={{ maxHeight: "50vh", overflowY: "auto" }}>
       {comments.length > 0 ? (
  [...comments]
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    .map((c, i) => (
      <Box key={i} sx={{ display: "flex", mb: 2 }}>
        <Avatar sx={{ mr: 2, bgcolor: "#1976d2" }}>
          {(c.name || c.createdBy?.name || "U")
            ?.charAt(0)
            ?.toUpperCase()}
        </Avatar>

        <Box>
          <Typography fontWeight={600}>
            {c.name || c.createdBy?.name || "User"}
          </Typography>

          <Typography variant="body2">
            {c.message || c.comment}
          </Typography>

       {c.file && c.file !== "null" && c.file.trim() !== "" && (
  <Box mt={1}>
    <img
      src={c.file}
      alt=""
      style={{
        maxWidth: "220px",
        borderRadius: "8px",
      }}
    />
  </Box>
)}
          <Typography variant="caption" color="text.secondary">
            {c.createdAt
              ? new Date(c.createdAt).toLocaleString("en-IN")
              : "-"}
          </Typography>
        </Box>
      </Box>
    ))
) : (
  <Typography>No Comments</Typography>
)}
      </Box>

      {/* SELECTED FILE PREVIEW */}
      {file && (
        <Box
          sx={{
            mt: 1,
            p: 1,
            background: "#e3f2fd",
            borderRadius: 1,
            fontSize: 13,
          }}
        >
          📎 {file.name}
        </Box>
      )}

      {/* INPUT BOX */}
      <Box sx={{ display: "flex", mt: 2 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Reply..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {/* + BUTTON */}
                <IconButton component="label">
                  <AddIcon />
                  <input
                    type="file"
                    hidden
                    onChange={handleFileChange}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <IconButton color="primary" onClick={handleSend}>
          <SendIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TicketCommentsDrawer;